export default __webpack_public_path__ + "static/media/beauty.f484d577.jpg";